// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Iqqq","content":"styles_content__3CTtR"};